export const query = state => {
  return {
    tradeName: state.tradeName,
    name: state.name,
    document: state.document,
    source: state.source
  }
}

export const loaded = (state) => {
  return state.loaded
}
